import React, { useEffect, useState } from "react";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import GRISidebar from "../../../../Layout/GRISidebar";
import styles from "../../../../styles/gri/general.module.css";
import InputField from "../../../../Components/Masters/InputField";
import { Box, Button, IconButton, Typography } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import { get, put } from "../../../../utils/api";
import { useNavigate, useParams } from "react-router-dom";
import { validateNumberInput } from "../../../../utils/validateFields";
import MessagePopup from "../../../../Components/Masters/MessagePopup";
import { restructureData } from "../../../../utils/restructureData";
import DynamicStaticTable from "../../../../Components/Common/DynamicStaticTable";
import StaticColumnTable from "../../../../Components/Common/StaticColumnTable";
import { Add, Delete } from "@mui/icons-material";
import DeleteRowDialog from "../../../../Components/Common/DeleteRowDialog";
import { validateLastRow } from "../../../../utils/validateTable";

import ReviewBox from "../../../../Components/Common/ReviewBox";
import { currentYear } from "../../../../utils/generateYearRanges";

const GRI305_2 = ({hide}) => {
    const [griReview, setGriReview] = useState(() => JSON.parse(localStorage.getItem("griReview")));
const inputData = [
    {
      fieldName: "biogenicCO2Emissions",
      title: "Total gross marked-based energy indirect (Scope 2) GHG Emissions",
      type: "array",
      letter: "b.",
      fields: [
        {
          fieldName: "emission",
          title: "Emission",
          type: "text",
          placeholder: "Enter Text",
          width: "30%",
        },
        {
          fieldName: "value",
          title: "Value",
          type: "number",
          width: "30%",
          placeholder: "Enter Number",
        },
        {
          fieldName: "unit",
          title: "Unit",
          width: "30%",
        },
      ],
    },
  ];

  const inputData1 = [
    {
      fieldName: "gasesIncluded",
      // title: "c. Gases included in the calculation:",
      type: "array",
      letter: "c.",
      fields: [
        {
          fieldName: "gasName",
          title: "Gas Name",
          type: "text",
          placeholder: "Enter Text",
          width: "44%",
        },
        // {
        //   fieldName: "unit",
        //   title: "Unit",
        //   type: "select",
        //   options: ["Tonns", "Liters", "M3", "Kg"],
        //   width: "30%",
        //   placeholder: "Select",
        // },
        {
          fieldName: "total",
          title: "Total Emission",
          type: "number",
          width: "44%",
          placeholder: "Enter Number",
        },
      ],
    },
  ];

  const defaultSegments = ["Marked-based emission"];

  const defaultSegments1 = ["CO2", "CH4", "N2O", "HFCs", "PFCs", "SF6", "NF3"];

  const questionData = [
    {
      fieldName: "total",
      title:
        "a. What is the total amount of greenhouse gas emissions in metric tons of CO2 equivalent emitted directly (Scope 2 emissions) by the organization?",
      type: "number",
      letter: "a.",
    },
    {
      fieldName: "countryEmission",
      title: "If available, provide Scope 2 emission country wise.",
      type: "text",
    },
    {
      fieldName: "baseYearEmissionData",
      title: "d. If applicable, define base year for the calculation:",
      type: "text",
      letter: "d.",
      fields: [
        {
          fieldName: "rationaleBehind",
          title: "i. The rationale behind the selection of the base year.",
          type: "text",
        },
        {
          fieldName: "totalEmission",
          title: "ii. Emission in metric tons of CO2 Equivalent.",
          type: "number",
        },
        {
          fieldName: "recalculationBaseYear",
          title:
            "iii. Provide context for any significant changes in emissions that prompted the recalculation of base year emissions.",
          type: "text",
        },
      ],
    },
    {
      fieldName: "emissionFactorsGWPReferences",
      title:
        "e. What is the source of the emission factors and global warming potential (GWP) rates used in emissions calculations? Provide references to the source if available.",
      type: "text",
      letter: "e.",
    },
    {
      fieldName: "emissionsConsolidationMethod",
      title:
        "f. How are emissions consolidated? Specify whether equity share, financial control, or operational control is utilized for consolidation purposes.",
      type: "text",
      letter: "f.",
    },
    {
      fieldName: "emissionsCalculationMethods",
      title:
        "g. What standards, methodologies, assumptions, and/or calculation tools were utilized in emissions calculations?",
      type: "text",
      letter: "g.",
    },
  ];

  const navigate = useNavigate();
  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);
  const [countryIndex, setCountryIndex] = useState();
  const [errors, setErrors] = useState({});
  const [tables, setTables] = useState([]);
  const [table1, setTable1] = useState([]);
  const [tabErrors, setTabErros] = useState({});
  const [data, setData] = useState({});
  const [formData, setFormData] = useState({});
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [openDialog, setOpenDialog] = React.useState(false);
  const [country, setCountry] = useState(false);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await get(`/gri/get?Id=${id}&type=GRI300`);
      if (res?.data?.data?.year ? res?.data?.data?.year < currentYear -1 : false) setDisabled(true);
      const res1 = res?.data?.data?.GRI300?.scope2Emissions;
      setData(res1);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    setFormData({
      total: data?.total || "",
      countryEmission: data?.countryEmission?.length
        ? data?.countryEmission?.map((item) => ({
            country: item?.country || "",
            value: item?.value || "",
          }))
        : [{ country: "", value: "" }],
      // biogenicCO2Emissions: data?.biogenicCO2Emissions || "",
      baseYearEmissionData: data?.baseYearEmissionData || {
        rationaleBehind: "",
        totalEmission: "",
        recalculationBaseYear: "",
      },
      emissionFactorsGWPReferences: data?.emissionFactorsGWPReferences || "",
      emissionsConsolidationMethod: data?.emissionsConsolidationMethod || "",
      emissionsCalculationMethods: data?.emissionsCalculationMethods || "",
    });
    if (
      data?.countryEmission?.length &&
      data?.countryEmission?.[data?.countryEmission?.length - 1]?.country !==
        "" &&
      data?.countryEmission?.[data?.countryEmission?.length - 1]?.value !== ""
    )
      setCountry(true);
  }, [data]);

  const handleChange = (fieldName, value, type, field, index) => {
    if (type === "number" && !validateNumberInput(value)) return;

    if (field === "value" || field === "country") {
      setFormData((prev) => ({
        ...prev,
        countryEmission: prev?.countryEmission?.map((item, i) =>
          i === index ? { ...item, [field]: value } : item
        ),
      }));
      if (
        field === "value" &&
        formData?.countryEmission?.[index]?.country !== "" &&
        value !== ""
      )
        setCountry(true);
      else if (
        field === "country" &&
        formData?.countryEmission?.[index]?.value !== "" &&
        value !== ""
      )
        setCountry(true);
      else setCountry(false);
    } else {
      field
        ? setFormData((prev) => ({
            ...prev,
            [fieldName]: { ...prev?.[fieldName], [field]: value },
          }))
        : setFormData((prev) => ({
            ...prev,
            [fieldName]: value,
          }));
    }

    console.log(formData);
  };

  const handleRemoveRow = (index) => {
    setCountryIndex(index); // Set the index of the row to be removed
    const isRowEmpty =
      formData?.countryEmission?.[index]?.country === "" &&
      formData?.countryEmission?.[index]?.value === "";
    if (isRowEmpty) {
      // If the row is empty, immediately remove it
      setFormData((prev) => ({
        ...prev,
        countryEmission: prev.countryEmission.filter((_, i) => i !== index), // Remove row at rowIndex
      }));
      setCountry(true);
      setErrors({});
    } else {
      // Otherwise, show the dialog for confirmation
      setOpenDialog(true);
    }
  };

  const cancelRemoveCountry = () => {
    setOpenDialog(false); // Close the confirmation dialog
  };

  const confirmRemoveCountry = () => {
    console.log(countryIndex);
    // Remove the row at rowIndex
    setFormData((prev) => ({
      ...prev,
      countryEmission: prev?.countryEmission.filter(
        (_, i) => i !== countryIndex
      ), // Remove row at rowIndex
    }));
    setErrors({});
    setCountry(true);
    setCountryIndex(); // Clear the rowIndex state
    setOpenDialog(false); // Close the confirmation dialog
  };

  const handleAddCountry = () => {
    setFormData((prev) => ({
      ...prev,
      countryEmission: [...prev?.countryEmission, { country: "", value: "" }], // Add a new object with countryEmission array
    }));
    setCountry(false);
  };

  const validateCountry = () => {
    const length = formData?.countryEmission?.length;
    const country = formData?.countryEmission?.[length - 1]?.country;
    const value = formData?.countryEmission?.[length - 1]?.value;
    if (length > 1) {
      if (country === "")
        setErrors((prev) => ({ ...prev, country: "Required" }));
      if (value === "") setErrors((prev) => ({ ...prev, value: "Required" }));

      if (value === "" || country === "") return false;
    }
    return true;
  };

  const handleSubmit = async () => {
    if (!disabled) {
      let v1 =
        table1?.[0]?.rows?.length > defaultSegments1?.length
          ? validateLastRow(inputData1, table1, setTabErros)
          : true;
      let v2 = validateCountry();

      if (!v1 || !v2) return;

      let transformedData2 = {
        scope2Emissions: {
          ...restructureData(tables),
          ...restructureData(table1),
          ...formData,
        },
        type: "GRI300",
        submitted305_2: true,
      };

      try {
        const res = await put(`/gri/update?Id=${id}`, transformedData2);
        setsnackOpen({
          open: true,
          message: res.data.message,
          severity: "success",
        });
        navigate(`/gri/gri300/305-3/${id}`);
      } catch (error) {
        console.log(error);
        setsnackOpen({
          open: true,
          message: error.data.message,
          severity: "error",
        });
      }
    } else {
      navigate(`/gri/gri300/305-3/${id}`);
    }
  };

  const isCountryAdded = () => {
    const countryLength = formData?.countryEmission?.length;
    const countryName = formData?.countryEmission?.[countryLength - 1]?.country;
    const countryValue = formData?.countryEmission?.[countryLength - 1]?.value;
    console.log(countryName, countryValue, "cntry");
    if (countryName !== "" && countryValue !== "") {
      setCountry(true);
    } else setCountry(false);
  };

  const renderContent = ({hide}) => (
     <>
      <MessagePopup {...{ snackOpen, setsnackOpen }} />{" "}
      <DeleteRowDialog
        {...{
          openDialog,
          cancelRemoveRow: cancelRemoveCountry,
          confirmRemoveRow: confirmRemoveCountry,
          disabled: disabled,
        }}
      />
      {!hide && <p className={styles.section_heading}>305 : Emissions</p>}
      <p className={styles.main_heading} style={{marginBottom : hide ? "-1.5rem" : "0", }}>
        305-2 : Energy indirect (Scope 2) GHG emissions
      </p>
      {questionData.map((el) => (
        <Box key={el.fieldName} sx={{ mt: hide ? "-1rem" : "1rem" }}>
          <Box
            sx={{
              display: "flex",
              gap: 0.5,
              ml: el?.fieldName === "countryEmission" && 2,
            }}
          >
            {/* <p className={styles.ques_heading}>{el.letter}</p> */}
            <p className={styles.ques_heading}>{el.title}</p>
          </Box>
          {el?.fields ? (
            el.fields.map((field, index) => (
              <Box sx={{ ml: 2.5 }} key={index}>
                <Typography sx={{ my: 2, fontWeight: 500, fontSize: "15px" }}>
                  {field?.title}
                </Typography>
                <Box sx={{ marginLeft: "1rem" }}>
                  <InputField
                    placeholder={
                      field?.type === "number" ? "Enter Number" : "Enter Text"
                    }
                    fieldName={field?.fieldName}
                    value={formData?.[el?.fieldName]?.[field.fieldName]}
                    handleChange={(e) => {
                      handleChange(
                        el?.fieldName,
                        e.target.value,
                        field?.type,
                        field?.fieldName
                      );
                    }}
                    mt="-5px"
                    disabled={disabled}
                  />
                </Box>
              </Box>
            ))
          ) : el?.fieldName === "countryEmission" ? (
            <Box>
              <Box sx={{ display: "flex", mt: "-1rem" }}>
                <Box>
                  {formData?.countryEmission?.map((country, i) => {
                    console.log("cou", country);
                    return (
                      <Box sx={{ display: "flex", ml: 2.5, gap: 1 }}>
                        <Box sx={{ width: "43%" }}>
                          <InputField
                            placeholder={"Enter Country Name"}
                            fieldName={"country"}
                            value={country?.country}
                            handleChange={(e) => {
                              handleChange(
                                el?.fieldName,
                                e.target.value,
                                el?.type,
                                "country",
                                i
                              );
                            }}
                            errors={Boolean(errors[el.fieldName])}
                            disabled={disabled}
                          />
                          <p
                            key={i}
                            color="error"
                            variant="caption"
                            style={{
                              lineHeight: "1.2",
                              margin: "2px 0",
                              color: "#d34040",
                              fontSize: "10px",
                              fontStyle: "italic",
                            }}
                          >
                            {i === formData?.countryEmission?.length - 1 &&
                              errors?.country}
                          </p>
                        </Box>
                        <Box sx={{ width: "40%" }}>
                          <InputField
                            placeholder={"tCO2e"}
                            fieldName={"value"}
                            value={country?.value}
                            handleChange={(e) => {
                              handleChange(
                                el?.fieldName,
                                e.target.value,
                                el?.type,
                                "value",
                                i
                              );
                            }}
                            errors={Boolean(errors[el.fieldName])}
                            disabled={disabled}
                          />
                          <p
                            key={i}
                            color="error"
                            variant="caption"
                            style={{
                              lineHeight: "1.2",
                              margin: "2px 0",
                              color: "#d34040",
                              fontSize: "10px",
                              fontStyle: "italic",
                            }}
                          >
                            {i === formData?.countryEmission?.length - 1 &&
                              errors?.value}
                          </p>
                        </Box>
                        {!hide &&
                        <IconButton
                          disabled={
                            formData?.countryEmission?.length === 1 || disabled
                          }
                          onClick={() => handleRemoveRow(i)}
                          color="error"
                        >
                          <Delete />
                        </IconButton>
                  }
                      </Box>
                    );
                  })}
                </Box>
                {!hide &&
                <Box>
                  <Button
                    endIcon={<Add />}
                    disabled={!country || disabled}
                    onClick={() => handleAddCountry()}
                    sx={{
                      marginTop: "0.5rem",
                      color: "#1C486B",
                      ml: 3,
                      width: "10rem",
                      borderColor: "#1C486B",
                      textTransform: "none",
                    }}
                    variant="outlined"
                  >
                    Add Country
                  </Button>
                </Box>
}
              </Box>
              <Box sx={{ mt: "1rem" }}>
                <StaticColumnTable
                  {...{
                    inputData,
                    tables,
                    setTables,
                    errors: errors,
                    setErrors: setErrors,
                    data: data,
                    defaultSegments,
                    parameter: "emission",
                    parameter2: "unit",
                    defaultSegments2: ["mtCO2 eq"],
                    disabled: disabled,
                  
                  }}
                />
              </Box>
              <Box sx={{ mt: "1rem" }}>
                <Box sx={{ display: "flex", gap: 1 }}>
                  <p className={styles.ques_heading}>
                    c. Gases included in the calculation:
                  </p>
                  <p className={styles.ques_heading}>Tons</p>
                </Box>
                <DynamicStaticTable
                  {...{
                    inputData: inputData1,
                    tables: table1,
                    setTables: setTable1,
                    errors: tabErrors,
                    setErrors: setTabErros,
                    data: data,
                    defaultSegments: defaultSegments1,
                    parameter: "gasName",
                    buttonHeading: "Add Other Gases",
                    disabled: disabled,
                      hide : hide
                  }}
                />
              </Box>
            </Box>
          ) : (
            <Box sx={{ ml: 2 }}>
              <InputField
                placeholder={
                  el?.type === "number" ? "Enter Number" : "Enter Text"
                }
                fieldName={el.fieldName}
                value={formData?.[el.fieldName]}
                handleChange={(e) => {
                  handleChange(el?.fieldName, e.target.value, el?.type);
                }}
                mt="-5px"
                errors={Boolean(errors[el.fieldName])}
                disabled={disabled}
              />
            </Box>
          )}
        </Box>
      ))}
      
    </>
  )

  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
            {!griReview ? (
        <Box sx={{ ml: "1rem", width: "98.3%" }}>
          <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
        </Box>
      ) : (
        <Box textAlign="right" sx={{ mt: 3 }}>
          <Button
            onClick={handleSubmit}
            variant="contained"
            sx={{ bgcolor: "#1C486B", textTransform: "none", mt: 3, mb: 5 }}
          >
            Save & Continue <EastIcon sx={{ ml: 2 }} />
          </Button>
        </Box>
      )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};

export default GRI305_2;
